module.exports = new __parcel__URL__("error.6d4f954a.png").toString();